import React from 'react';

import ModalView from '../modalView';

const EditEvent = props => (
  <ModalView title="Edit event" titleAction="Update" {...props} />
);

export default EditEvent;
